<template>
   <div class="row">
        <div class="col-12 col-sm-6 col-xl">
            <select-input label="Campaign" v-model="selectedCampaign">
                <option value="0">Choose</option>
                <option v-for="(option, index) in campaigns" :key="index" :value="option.id">
                    {{ option.name }}
                </option>
            </select-input>
        </div>
        <div class="col-12 col-sm-6 col-xl">
            <select-input label="Agreement" v-model="selectedAgreement">
                <option value="0">Choose</option>
                <option v-for="(option, index) in agreements" :key="index" :value="option.id">
                    {{ option.name }}
                </option>
            </select-input>
        </div>
        <div class="col-12 col-sm-6 col-xl">
            <select-input label="Publisher" v-model="selectedPublisher">
                <option value="0">Choose</option>
                <option v-for="(option, index) in publishers" :key="index" :value="option.id">
                    {{ option.name }}
                </option>
            </select-input>
        </div>
        <div class="col-12 col-sm-6 col-xl">
            <select-input label="Brand" v-model="selectedBrand">
                <option value="0">Choose</option>
                <option v-for="(option, index) in brands" :key="index" :value="option.id">
                    {{ option.name }}
                </option>
            </select-input>
        </div>
    </div>
</template>

<script>
import SelectInput from '../Inputs/SelectInput.vue';

export default {
    components: {
        SelectInput
    },
    props: {
		campaigns: { type: Array, required: true },
        agreements: { type: Array, required: true },
        brands:  { type: Array, required: true },
        publishers:  { type: Array, required: true },
    },
    data() {
        return {
            selectedCampaign: 0,
            selectedAgreement: 0,
            selectedPublisher: 0,
            selectedBrand: 0,
        }
    },
    watch: {
        selectedCampaign(newValue) {
            this.$emit('campaignChanged', newValue);
        },
        selectedAgreement(newValue) {
            this.$emit('agreementChanged', newValue);
        },
        selectedPublisher(newValue) {
            this.$emit('publisherChanged', newValue);
        },
        selectedBrand(newValue) {
            this.$emit('brandChanged', newValue);
        },
    }
}
</script>